'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _style = require('./style');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = function Login(props) {
  return _react2.default.createElement(
    'div',
    { className: _style2.default.container },
    _react2.default.createElement(
      'form',
      null,
      _react2.default.createElement(
        _reactBootstrap.FormGroup,
        { bsSize: 'large', className: _style2.default.formGroup },
        _react2.default.createElement(
          'h2',
          null,
          '\u8ACB\u767B\u5165'
        ),
        _react2.default.createElement(_reactBootstrap.FormControl, {
          type: 'text',
          placeholder: '\u5E33\u865F',
          value: props.account,
          onChange: function onChange(event) {
            return props.setAccount(event.target.value);
          },
          autoFocus: true
        }),
        _react2.default.createElement(_reactBootstrap.FormControl, {
          type: 'password',
          placeholder: '\u5BC6\u78BC',
          value: props.password,
          onChange: function onChange(event) {
            return props.setPassword(event.target.value);
          },
          onKeyUp: function onKeyUp(event) {
            return event.keyCode === 13 ? props.login() : null;
          }
        }),
        _react2.default.createElement(
          _reactBootstrap.Button,
          {
            className: _style2.default.submitBtn,
            type: 'button',
            bsStyle: 'primary', bsSize: 'large', block: true,
            onClick: props.login
          },
          '\u767B\u5165'
        ),
        props.message ? _react2.default.createElement(
          _reactBootstrap.Alert,
          { bsStyle: props.messageStyle },
          props.message
        ) : null
      )
    )
  );
};

var string = _propTypes2.default.string,
    func = _propTypes2.default.func;

Login.propTypes = {
  account: string.isRequired,
  password: string.isRequired,
  setAccount: func.isRequired,
  setPassword: func.isRequired,
  login: func.isRequired,
  message: string,
  messageStyle: string
};

exports.default = Login;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Login/Login.js
// module id = 767
// module chunks = 0